<template>
  <header class="header">
    <!-- TODO: 需要固定到顶部 -->
    <div class="header-top">
      <section
        class="header-top-main main-center flex items-center justify-between"
      >
        <div class="welcome-title flex items-center">
          欢迎来到山东教育社
          <div v-if="!$store.state.token">
            ，请
            <router-link class="main-cl" to="/login?islogin=1">登录</router-link>
            <span class="welcome-line">|</span>
            <router-link to="/login">注册</router-link>
          </div>
          <div v-else class="main-cl pointer" style="margin-left: .2rem" @click="toLogout">退出登录</div>
        </div>

        <div class="header-top_right flex">
          <!-- 头部页面跳转模块 -->
          <div class="header-top_links flex items-center">
            <router-link to="/orders" class="header-top_link flex items-center">
              <i class="iconfont icon-wodedingdan"></i>
              我的订单
            </router-link>
            <i class="header-top_link-line"></i>
            <router-link to="/center" class="header-top_link flex items-center">
              <i class="iconfont icon-zhanghuguanli"></i>
              账户管理
            </router-link>
          </div>
          <!-- 售后电话 -->
          <div class="sale-phone">
            <a class="flex items-center" :href="`tel:${headerInfo.after_sales_phone}`">
              <img
                class="sale-phone-icon"
                src="@/assets/images/sale-phone-icon.png"
                alt=""
              />
              <p>
                <span class="sale-phone_label bold">售后电话:</span> {{headerInfo.after_sales_phone}}
              </p>
            </a>
          </div>
        </div>
      </section>
    </div>

    <div
      class="header-bottom-main main-center flex items-center justify-between"
    >
      <router-link to="/">
        <img class="header-logo" src="@/assets/images/logo.png" alt="" />
      </router-link>

      <div class="flex items-center">
        <div class="header-search-box flex white-bg">
          <div class="header-search-input-box flex items-center flex-1">
            <i class="iconfont icon-sousuo"></i>
            <input
              v-model="keyword"
              class="header-search-input flex-1"
              type="text"
              maxlength="30"
              placeholder="请输入搜索内容"
            />
          </div>
          <router-link class="header-search-btn" :to="`/goods/type?keyword=${keyword}`">
            <com-button label="搜索" class-name="f18"></com-button>
          </router-link>
        </div>
        <!-- 购物车 -->
        <router-link to="/shopcar">
          <com-button label="购物车">
            <template #prefix>
              <i class="com-btn_prefix iconfont icon-gouwuche"></i>
            </template>
            <template #suffix>
              <span class="com-btn_suffix f14">({{ $store.state.shopCarCount }})</span>
            </template>
          </com-button>
        </router-link>
      </div>
      <!-- 公众号二维码 -->
      <div class="public-qrcode text-center white-bg">
        <img
          class="header-qrcode"
          :src="headerInfo.wechat_official_qr"
          alt=""
        />
        微信公众号
      </div>
    </div>
  </header>
</template>

<script>
import ComButton from "@/components/ComButton.vue";
import { logout } from '@/apis/user';
import { querySiteInfo } from '@/apis/notice';
import { MessageBox } from 'element-ui'

export default {
  components: {
    ComButton,
  },
  data: ()=>({
    keyword: '',
    headerInfo: {}
  }),
  created(){
    this.getHeaderInfo()
  },
  methods: {
    toLogout(){
      MessageBox.confirm(`是否确定要退出?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then(()=>{
          this.$store.commit('setUserInfo', null);
          this.$store.commit('changeShopCarCount', 0);
          this.$store.commit('setToken', '');
          this.$router.push('/');
        })
      })
    },
    getHeaderInfo(){
      querySiteInfo({
        is_wechat_qr: this.runEnv === "pc" ? 1 : 2
      }).then(({result})=>{
        this.headerInfo = result;
      })
    }
  },
};
</script>

<style lang="less" scoped>
@header-height: 0.5rem;
@seachHeight: 0.5rem;
@seachWidth: 5.8rem;

.header {
  color: #666;

  .welcome-line {
    padding: 0 0.14rem;
  }

  &-top {
    background: #f5f5f5;

    &-main {
      height: @header-height;
    }
  }
  &-top_link {
    &:hover{
      color: #d8271c;
    }
    .iconfont{
      margin-right: .1rem;
    }
  }
  // 头部右侧跳转模块(订单、账户管理跳转)
  &-top_link-line {
    width: 0.4rem;
    height: 12px;
    display: block;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 100%;
      width: 1px;
      background: #bbb;
    }
  }
  // 头部右侧模块
  &-top_right {
    .sale-phone {
      margin-left: 0.3rem;
      &_label {
        margin-right: 0.1rem;
      }
      .sale-phone-icon {
        box-shadow: 0px 4px 9px 1px rgba(216, 39, 28, 0.14);
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
}

.header-bottom-main {
  padding-top: 22px;
  padding-bottom: 22px;

  .header-logo {
    height: 0.47rem;
    max-width: 2.06rem;
  }

  // 顶部搜索
  .header-search-box {
    width: @seachWidth;
    height: @seachHeight;
    overflow: hidden;
    border-right: 0;
    position: relative;
    border-radius: @seachHeight / 2;
    margin-right: 14px;
    .header-search-btn{
      position: absolute;
      right: 0;
      z-index: 1;
    }
    .header-search-input-box{
      background: #fff;
      padding-left: 22px;
      border: 2px solid #d8271c;
      border-radius: @seachHeight / 2;
      border-top-right-radius: 0;
      border-right: 0;
      border-bottom-right-radius: 0;
      padding-right: 1.2rem;
    }

    .com-btn {
      font-size: 18px;
    }

    .icon-sousuo {
      margin-right: 8px;
    }
  }

  .public-qrcode {
    padding: 3px 6px 6px;
    border-radius: 6px;
    font-size: 12px;
    color: #878787;

    .header-qrcode {
      width: 0.78rem;
    }
  }
}

@media (max-width: 1024px) {
  .header-bottom-main {
    .header-search-box {
      width: 4.8rem;
    }
    .header-logo {
      height: 0.4rem;
    }
  }
}

@media (max-width: 920px) {
  .header-bottom-main {
    .header-search-box {
      width: 3.8rem;
    }
    .header-logo {
      height: 0.4rem;
    }
  }
}
</style>
